module.exports = __webpack_public_path__ + "static/media/narsharab.540cc2b7.png";